export default __webpack_public_path__ + "apply10943c33.png";